import { LanguageContextConsumer } from "@contexts";
import {
  cn,
  datesAreOnSameDay,
  getDateWithLeadingZero,
  isPastEvent,
} from "@lib";
import { Body1, Overline } from "@ui/typography";
import PropTypes from "prop-types";
import React from "react";

import * as styles from "./DateBadge.module.scss";

const getMonth = (time) =>
  [
    { nb: "Jan", en: "Jan" },
    { nb: "Feb", en: "Feb" },
    { nb: "Mar", en: "Mar" },
    { nb: "Apr", en: "Apr" },
    { nb: "Mai", en: "May" },
    { nb: "Jun", en: "Jun" },
    { nb: "Jul", en: "Jul" },
    { nb: "Aug", en: "Aug" },
    { nb: "Sep", en: "Sep" },
    { nb: "Okt", en: "Oct" },
    { nb: "Nov", en: "Nov" },
    { nb: "Des", en: "Dec" },
  ][time.getMonth()];

export const DateBadge = ({ startTime, endTime, align = "center" }) => {
  let startMonth, endMonth;
  startTime = (startTime && new Date(startTime)) || null;
  endTime = (endTime && new Date(endTime)) || null;
  const long = startTime && endTime && !datesAreOnSameDay(startTime, endTime);

  if (long) {
    startMonth = getMonth(startTime);
    endMonth = getMonth(endTime);
  }

  const className = cn(
    styles.badgeWrapper,
    styles[align],
    isPastEvent(startTime, endTime) ? styles.isPastEvent : "",
  );
  return (
    <LanguageContextConsumer>
      {({ localize }) => {
        if (long) {
          return (
            <div className={cn(className, styles.longBadge)}>
              <div className={cn(styles.badge)}>
                <Body1 className={styles.date}>
                  {getDateWithLeadingZero(startTime)}
                </Body1>
                <Overline className={styles.month}>
                  {localize(startMonth)}
                </Overline>
              </div>
              <div className={styles.dash}>—</div>
              <div className={styles.badge}>
                <Body1 className={styles.date}>
                  {getDateWithLeadingZero(endTime)}
                </Body1>
                <Overline className={styles.month}>
                  {localize(endMonth)}
                </Overline>
              </div>
            </div>
          );
        } else if (startTime) {
          return (
            <div className={cn(className, styles.singleBadge)}>
              <div className={styles.badge}>
                <Body1 className={styles.date}>
                  {getDateWithLeadingZero(startTime)}
                </Body1>
                <Overline className={styles.month}>
                  {localize(getMonth(startTime))}
                </Overline>
              </div>
            </div>
          );
        }
      }}
    </LanguageContextConsumer>
  );
};

DateBadge.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
};
